// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

import type { BorderSize } from './constants';

export const ThWrapper = styled.th<{
  isFirst?: boolean;
  isLast?: boolean;
  border?: BorderSize;
}>(
  ({ isFirst, isLast, border }) => css`
    ${
      isFirst &&
      css`
      border-top-left-radius: ${border};
      border-bottom-left-radius: ${border};
    `
    }

    ${
      isLast &&
      css`
      border-top-right-radius: ${border};
      border-bottom-right-radius: ${border};
    `
    }
  `,
);
